import React from 'react';

const RentalRequestUserThumbType = () => {
    return (
        <div>

        </div>
    );
};

export default RentalRequestUserThumbType;